import { z } from "zod";

export const splitTransactionDataSchema = z.object({
    date: z.coerce.date(),
    bankDescription: z.string().default(""),
    splitDescription: z.string().optional(),
    displayDescription: z.string().optional(),
    categoryId: z.string().optional(),
    categoryLabel: z.string().optional(),
    accountId: z.string().nullable().optional(),
    accountLabel: z.string().optional(),
    amount: z.coerce.number().default(0),
    originalAmount: z.coerce.number().default(0),
    entityId: z.coerce.number().nullable().optional(),
    financialAccountId: z.coerce.number().optional(),
});

/**
 * Cash-ledger account info shown in the GL-first "Cash ledger" column of the
 * split drawer. `accountId` resolves the live account; `accountLabel` is a
 * fallback when the account can no longer be resolved.
 */
export interface SplitLedgerInfo {
    accountId?: string;
    accountLabel?: string;
}
